import { getServiceClient } from '@api/client-factory/StoreManagementClientFactory'

import {
    ListStoreIssuesInput,
    ListStoreIssuesOutput,
    GetIssueInput,
    GetIssueOutput,
    DownloadAttachmentInput,
    DownloadAttachmentOutput,
    CreateIssueInput,
    CreateIssueOutput,
    UpdateIssueInput,
    UpdateIssueOutput,
    PostCorrespondenceInput,
    PostCorrespondenceOutput,
    UploadAttachmentInput,
    UploadAttachmentOutput,
    StartChatInput,
    StartChatOutput,
} from '@amzn/coral_com-amazon-jwoconnect'
import { validateRequired } from './listenerUtils'

// ========================================
// READ OPERATIONS (ViewBringUp)
// ========================================

export async function listStoreIssuesListener (message: any): Promise<ListStoreIssuesOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.listStoreIssues(ListStoreIssuesInput.clone(params)).toPromise()
}

export async function getIssueListener (message: any): Promise<GetIssueOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.getIssue(GetIssueInput.clone(params)).toPromise()
}

export async function downloadAttachmentListener (message: any): Promise<DownloadAttachmentOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.downloadAttachment(DownloadAttachmentInput.clone(params)).toPromise()
}

// ========================================
// WRITE OPERATIONS (ManageBringUp)
// ========================================

export async function createIssueListener (message: any): Promise<CreateIssueOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.createIssue(CreateIssueInput.clone(params)).toPromise()
}

export async function updateIssueListener (message: any): Promise<UpdateIssueOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.updateIssue(UpdateIssueInput.clone(params)).toPromise()
}

export async function postCorrespondenceListener (message: any): Promise<PostCorrespondenceOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.postCorrespondence(PostCorrespondenceInput.clone(params)).toPromise()
}

// The gateway operation is UploadIssueAttachment because UploadAttachment is GWT's.
export async function uploadIssueAttachmentListener (message: any): Promise<UploadAttachmentOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.uploadIssueAttachment(UploadAttachmentInput.clone(params)).toPromise()
}

export async function startChatListener (message: any): Promise<StartChatOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.startChat(StartChatInput.clone(params)).toPromise()
}
